<script lang="ts" setup>
// ================================
// Composables
// ================================
const route = useRoute();
const { t } = useI18n();
const { stepperItems } = useBaselineConstants();
const { baseline } = storeToRefs(baselineStore());

// ================================
// Data
// ================================
const breadcrumb = [
  {
    name: t('baseline.baselines'),
    url: '/references/baselines',
  },
];

// ================================
// Computed
// ================================
const activeStep = computed(() => {
  return stepperItems.value.findIndex((item) => item.routeName === route.name);
});

// ================================
// Methods
// ================================
const nextStep = () => {
  const nextStep = stepperItems.value[activeStep.value + 1];
  if (!nextStep) return;
  navigateTo({
    name: nextStep.routeName,
  });
};

const previousStep = () => {
  const previousStep = stepperItems.value[activeStep.value - 1];
  if (!previousStep) return;
  navigateTo({
    name: previousStep.routeName,
  });
};

// ================================
// Lifecycle
// ================================
onMounted(() => {
  if (route.name !== 'baseline-create-energy-use' && !baseline.value) {
    navigateTo({
      name: 'baseline-create-energy-use',
    });
  }
});
</script>
<template>
  <div class="flex flex-col h-screen overflow-hidden">
    <ui-header :title="$t('baseline.new_baseline')" :breadcrumb="breadcrumb" />
    <div class="flex flex-col items-center gap-4 p-4 overflow-y-auto">
      <div class="max-w-[1000px] w-full pt-4 group group-hover:cursor-pointer">
        <u-stepper v-model="activeStep" :items="stepperItems" class="my-6" disabled />
        <nuxt-page @next="nextStep" @previous="previousStep" />
      </div>
    </div>
  </div>
</template>
